import { ReportedHeartBeatStatus, HeartBeatStatusIndicators } from '@Types';
import { getComponentStatus } from '../utils/getComponentStatus';
import { CertificateStatus } from '@Types/implementation';

// High level translation of the cert status and shadow to visible icons:
// Disabled if
// cert status is disabled
//
// Disconnected (icon representing never connected) if
// No shadow
// empty shadow
// cert status idle or
// cert statys pending
//
// green if
// All components report status=good AND all timestamps < 6 minutes ago
//
// yellow if
// All components report status=good AND all timestamps < 11 minutes ago
//
// red
// Any component reports status other than good, or any timestamp > 11 minutes ago
export const getComponentStatusIndicator = (
	reportedComponentStatus: ReportedHeartBeatStatus,
	certificateStatus: CertificateStatus | undefined,
): HeartBeatStatusIndicators => {
	if (
		certificateStatus?.status === 'idle' ||
		certificateStatus?.status === 'pending'
	) {
		return HeartBeatStatusIndicators.Disconnected;
	}

	if (
		certificateStatus?.status === 'success' &&
		certificateStatus?.response?.status === 'Disabled'
	) {
		return HeartBeatStatusIndicators.Disabled;
	}

	if (reportedComponentStatus?.state.length <= 0) {
		return HeartBeatStatusIndicators.Disconnected;
	}

	let heartBeatStatusIndicator: HeartBeatStatusIndicators =
		HeartBeatStatusIndicators.Green;

	for (const component of reportedComponentStatus.state) {
		const componentStatus: HeartBeatStatusIndicators = getComponentStatus(
			component.timestamp,
			component.state,
			component.componentName,
		);

		if (componentStatus === HeartBeatStatusIndicators.Red) {
			return HeartBeatStatusIndicators.Red;
		} else if (componentStatus === HeartBeatStatusIndicators.Yellow) {
			heartBeatStatusIndicator = HeartBeatStatusIndicators.Yellow;
		}
	}

	return heartBeatStatusIndicator;
};
